/**
 * Les routes poussées du lot Compte et paramètres : celles qu'il fait passer sur le design system.
 *
 * Pontées par le socle : `account`, `settings`, `account-password`, `account-close` ; par ce lot :
 * `validate-email`, que « Mon compte » pousse (route partagée — le parent et le tuteur gardent
 * l'ancien écran, `validateEmailRoute.test.tsx`). Une route
 * inscrite ici rend l'écran des ports pour un élève dont l'espace est allumé, hors espace parent et
 * hors live, et son écran legacy ailleurs.
 *
 * Chaque écran n'est chargé qu'à son premier rendu (`loadedOnRender`).
 */
import { loadedOnRender } from "../loadedOnRender"
import { type StudentSpaceRouteTable } from "../studentSpaceRouteTypes"

/* eslint-disable @typescript-eslint/no-require-imports */
export const accountRoutes: StudentSpaceRouteTable<"account"> = {
    account: loadedOnRender(() => require("./StudentAccountScreen").StudentAccountScreen, "StudentAccountScreen"),
    settings: loadedOnRender(() => require("./StudentSettingsScreen").StudentSettingsScreen, "StudentSettingsScreen"),
    "account-password": loadedOnRender(
        () => require("./StudentPasswordScreen").StudentPasswordScreen,
        "StudentPasswordScreen"
    ),
    "account-close": loadedOnRender(
        () => require("./StudentCloseAccountScreen").StudentCloseAccountScreen,
        "StudentCloseAccountScreen"
    ),
    "validate-email": loadedOnRender(
        () => require("./StudentValidateEmailScreen").StudentValidateEmailScreen,
        "StudentValidateEmailScreen"
    ),
}
/* eslint-enable @typescript-eslint/no-require-imports */
